import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { SelectedPaymentPlan } from "./confirm-payment-plan/selected-payment-plan";

@Injectable({
  providedIn: 'root'
})
export class SetupPaymentPlanService {

  private _collectionsOrderId: BehaviorSubject<string> = new BehaviorSubject<string>('');


  constructor(private httpClient: HttpClient) {
  }

  get collectionsOrderId(): string {
    return this._collectionsOrderId.getValue();
  }

  set collectionsOrderId(value: string) {
    this._collectionsOrderId.next(value);
  }

  submitPaymentPlan(paymentPlan: SelectedPaymentPlan): Observable<any> {
    return this.httpClient.post<any>('/api/dashboard/paymentPlan/' + this.collectionsOrderId, paymentPlan);
  }
}
